import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { skipWhile, map, take } from 'rxjs/operators';
import { BET_97 } from './BET_97';
import { UntypedFormControl } from '@angular/forms';

export const BET_90: Flow_0_0_2 = {
	id: '90',
	name: 'assessor_to_visit_site',
	itemType: 'flow',
	fetchLevel1And2: BET_97.fetchLevel1And2,
	header: {
		title: (store, bf) => {
			bf.bigForm.addControl('workflow_current_state', new UntypedFormControl(90));
			return store.select(getFullItemOne).pipe(
				skipWhile(res => !res),
				take(1),
				map(itemOne => {
					if (itemOne) {
						let title = 'Assessor To Visit Site';
						if (itemOne?.loan_information?.mavenclaimnumber) {
							title += ` : ${itemOne?.loan_information?.mavenclaimnumber}`;
						}
						if (itemOne.applicant?.surname) {
							title += ` - ${itemOne.applicant?.surname}`;
						}

						return title;
					} else {
						return 'Assessor to Visit Site';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		...BET_97.footer
	},
	instructions: {
		editRoles: {
			0: 'Assessor to visit site'
		},
		viewRoles: {
			0: 'Assessor to visit site'
		}
	},
	actionPanel: BET_97.actionPanel,
	serverCalls: {
		...BET_97.serverCalls
	},
	startNode: 'JobSummary',
	nodes: {
		...BET_97.nodes
	},
	bigFormToStoreMapper: {
		...BET_97.bigFormToStoreMapper
	}
};
